import { VideoCameraIcon } from '@heroicons/react/20/solid';
import { useTranslation } from 'next-i18next';
import { Tooltip } from '@components/common/Tooltip/GlobalTooltip';

export const VideoCvBadge = () => {
  // Translation
  const { t } = useTranslation('common');

  // Render component
  // *****************************************
  return (
    <span className="absolute -inset-x-1 -bottom-2 block">
      <Tooltip
        tooltipText={t('video.cv.badge.tooltip')}
        position="bottom"
        className="block w-full rounded-full bg-surface py-0.5 text-pico font-medium text-primary shadow-xs"
        triggerContainerClass="flex items-center justify-center gap-1 whitespace-nowrap"
        contentSizeClass="max-w-48"
        floating
      >
        <VideoCameraIcon className="size-3.5 shrink-0" />
        <span className="inline-block shrink-0 pt-0.5 uppercase">
          {t('profile.similar.has.video.cv')}
        </span>
      </Tooltip>
    </span>
  );
};
